function CustomButton({ props }) {
  return (
    <button
      onClick={props.onClick}
      type="submit"
      className="w-full bg-[#65a59a] text-white shadow px-4 py-2 rounded-md hover:bg-[#79bbaf] transition duration-200"
    >
      {props.title || "Button"}
    </button>
  );
}

export default CustomButton;
